import React from 'react';
import { X } from 'react-bootstrap-icons';

import { Container } from './ChipStyles';

type Props = {
  label: string,
  onDelete: () => void
};

export const Chip: React.FC<Props> = ({ label, onDelete }) => {
  return (
    <Container>{label}<X onClick={onDelete} size={18} color='#999999' /></Container>
  )
};